import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { initI18n } from './lib/i18n'
import './styles/global.css'

async function bootstrap() {
  await initI18n('vi')
  const rootEl = document.getElementById('root')
  if (!rootEl) throw new Error('#root missing')
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void bootstrap()
